<template>
  <div class="svg-pill" :style="iconStyle">
    <component :is="iconType" />
  </div>
</template>

<script>
import pills from "./pills";
export default {
  name: "SvgPill",
  components: {
    ...pills
  },
  props: {
    iconType: {
      type: String,
      default: () => null
    },

    width: {
      type: [Number, String],
      default: 106
    },
    height: {
      type: [Number, String],
      default: "auto"
    }
  },
  computed: {
    iconStyle() {
      const { width, height } = this;
      return {
        width: `${width}px`,
        height: `${height}px`
      };
    }
  }
};
</script>

<style scoped></style>
